
<script>
// 组别列表
export default {
  props: {
    list: {
      type: Array,
      required: true
    }
  },
  methods: {
    goGroupList(item) {
      this.$router.push({
        path: '/match/home',
        query: { matchId: item.id }
      })
    }
  }
};
</script>

<template>
  <div class="match-group-container flex">
    <div class="match-group-item bg1 padding-12 text-center" v-for="item in list" :key="item.id" @click="goGroupList(item)">
      {{ item.name }}
    </div>
  </div>
</template>
<style src="@/tbs/stylesheet/dynamic.css" />
<style scoped lang="scss">
.match-group-container {
  flex-wrap: wrap;
  gap: 12px;
  .match-group-item {
    width: 40%;
    line-height: 30px;
    height: 30px;
  }
}
</style>

